import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthUserService } from '@services/auth-user.service';

@Component({
  selector: 'app-home',
  template: '<div></div>',
  standalone: false,
})
export class HomeComponent implements OnInit {
  authUserService = inject(AuthUserService);
  private router = inject(Router);

  ngOnInit() {
    if (this.authUserService.isStudent()) {
      this.router.navigateByUrl('/my-space', { replaceUrl: true });
    } else {
      this.router.navigateByUrl('/timeline/teacher', { replaceUrl: true });
    }
  }
}
